const BOUNCED = 'bounce';
const INVALID = 'invalid';
const SPAM = 'spamreport';
const UNSUBSCRIBED = 'unsub_global';

export const EMAIL_STATUS_VALUE = {
  [BOUNCED]: 'Email Bounced',
  [INVALID]: 'Email Invalid',
  [SPAM]: 'Email Reported as Spam',
  [UNSUBSCRIBED]: 'Email Unsubscribed',
};
